"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLatestDrawHistory = exports.getDrawWithAdditionalInformation = exports.getDrawsByPromotion = exports.getDrawPrizesWithWinners = exports.fetchDrawPrizesWithWinners = exports.getDrawPrizesWithContent = exports.getDrawEntries = exports.fetchDrawPrizesById = exports.fetchGiveawayPromotionDraws = exports.postGiveawayEntries = exports.getGiveawayEntriesDetails = exports.getGiveawayEntries = exports.fetchDetailsPageProgressivePrizes = exports.fetchProgressivePrizes = exports.fetchEligibleGamesByIds = exports.fetchEligibleGames = exports.fetchLatestDrawHistory = exports.fetchDrawPrizesWithContent = exports.fetchDrawPrizes = exports.fetchDrawWithAdditionalInformation = exports.selectPromotion = exports.selectGiveawayDraw = exports.selectDraw = exports.fetchDrawEntries = exports.resetByPromotion = exports.fetchDrawsByPromotion = exports.fetchPromotionDetails = exports.loadMore = exports.fetchPromotionsWithoutFeatured = exports.fetchPromotions = void 0;
var types_1 = require("@pbl/pbl-react-core/lib/models/draws/types");
var services_1 = require("@pbl/pbl-react-core/lib/services");
var constants_1 = __importDefault(require("../../../config/constants"));
var action_type_util_1 = require("../../action-type.util");
var fetchPromotionsByType = function (type, page, isLoadMore, excludeFeatured) {
    if (isLoadMore === void 0) { isLoadMore = false; }
    return __awaiter(void 0, void 0, void 0, function () {
        var size, _a, promotions, promotions, promotions;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    size = constants_1.default.DRAWS_PER_PAGE + (isLoadMore ? 0 : 1);
                    _a = type;
                    switch (_a) {
                        case types_1.PromotionType.GIVEAWAY: return [3, 1];
                        case types_1.PromotionType.SECOND_CHANCE: return [3, 6];
                    }
                    return [3, 11];
                case 1:
                    promotions = void 0;
                    if (!excludeFeatured) return [3, 3];
                    return [4, services_1.PromotionsService.fetchPromotions({
                            page: page,
                            size: size
                        }, 'GIVEAWAY', true)];
                case 2:
                    promotions = _b.sent();
                    return [3, 5];
                case 3: return [4, services_1.PromotionsService.fetchGiveawayPromotions({
                        page: page,
                        size: size
                    })];
                case 4:
                    promotions = _b.sent();
                    _b.label = 5;
                case 5: return [2, promotions];
                case 6:
                    promotions = void 0;
                    if (!excludeFeatured) return [3, 8];
                    return [4, services_1.PromotionsService.fetchPromotions({
                            page: page,
                            size: size
                        }, 'SECOND_CHANCE', true)];
                case 7:
                    promotions = _b.sent();
                    return [3, 10];
                case 8: return [4, services_1.PromotionsService.fetchSecondChancePromotions({
                        page: page,
                        size: size
                    })];
                case 9:
                    promotions = _b.sent();
                    _b.label = 10;
                case 10: return [2, promotions];
                case 11: return [4, services_1.PromotionsService.fetchPromotions({
                        page: page,
                        size: size
                    })];
                case 12:
                    promotions = _b.sent();
                    return [2, promotions];
            }
        });
    });
};
var fetchPromotions = function (promotionType, excludeFeatured) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var promotions, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({
                    type: (0, action_type_util_1.REQUEST)(types_1.FETCH_PROMOTIONS)
                });
                return [4, fetchPromotionsByType(promotionType, 0, false, excludeFeatured)];
            case 1:
                promotions = _a.sent();
                if (promotions && promotions.content && promotions.content.length > 0) {
                    promotions.content.map(function (item) { return __awaiter(void 0, void 0, void 0, function () {
                        var draw, _a;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    if (!(item.promotionType === types_1.PromotionType.PROGRESSIVE)) return [3, 3];
                                    return [4, fetchActiveDraw(item.id, true)];
                                case 1:
                                    draw = _b.sent();
                                    if (draw) {
                                        item.progressiveDrawDate = draw.draw;
                                        item.progressiveEntryEndDate = draw.end;
                                        item.progressiveDrawNumber = draw.drawNumber;
                                    }
                                    _a = item;
                                    return [4, fetchProgressivePrize(item.id, draw, true)];
                                case 2:
                                    _a.progressivePrize = _b.sent();
                                    _b.label = 3;
                                case 3: return [2, item];
                            }
                        });
                    }); });
                }
                dispatch({
                    type: (0, action_type_util_1.SUCCESS)(types_1.FETCH_PROMOTIONS),
                    payload: promotions
                });
                return [3, 3];
            case 2:
                error_1 = _a.sent();
                dispatch({
                    type: (0, action_type_util_1.FAILURE)(types_1.FETCH_PROMOTIONS),
                    payload: { error: error_1 }
                });
                return [3, 3];
            case 3: return [2];
        }
    });
}); }; };
exports.fetchPromotions = fetchPromotions;
var fetchPromotionsWithoutFeatured = function (promotionType, excludeFeatured) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var promotions, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({
                    type: (0, action_type_util_1.REQUEST)(types_1.FETCH_PROMOTIONS_WITHOUT_FEATURED)
                });
                return [4, fetchPromotionsByType(promotionType, 0, true, excludeFeatured)];
            case 1:
                promotions = _a.sent();
                if (promotions && promotions.content && promotions.content.length > 0) {
                    promotions.content.map(function (item) { return __awaiter(void 0, void 0, void 0, function () {
                        var draw, _a;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    if (!(item.promotionType === types_1.PromotionType.PROGRESSIVE)) return [3, 3];
                                    return [4, fetchActiveDraw(item.id, true)];
                                case 1:
                                    draw = _b.sent();
                                    if (draw) {
                                        item.progressiveDrawDate = draw.draw;
                                        item.progressiveEntryEndDate = draw.end;
                                        item.progressiveDrawNumber = draw.drawNumber;
                                    }
                                    _a = item;
                                    return [4, fetchProgressivePrize(item.id, draw, true)];
                                case 2:
                                    _a.progressivePrize = _b.sent();
                                    _b.label = 3;
                                case 3: return [2, item];
                            }
                        });
                    }); });
                }
                dispatch({
                    type: (0, action_type_util_1.SUCCESS)(types_1.FETCH_PROMOTIONS_WITHOUT_FEATURED),
                    payload: promotions
                });
                return [3, 3];
            case 2:
                error_2 = _a.sent();
                dispatch({
                    type: (0, action_type_util_1.FAILURE)(types_1.FETCH_PROMOTIONS_WITHOUT_FEATURED),
                    payload: { error: error_2 }
                });
                return [3, 3];
            case 3: return [2];
        }
    });
}); }; };
exports.fetchPromotionsWithoutFeatured = fetchPromotionsWithoutFeatured;
var loadMore = function (page, promotionType, excludeFeatured) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var promotions, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, fetchPromotionsByType(promotionType, page, page >= 0, excludeFeatured)];
                case 1:
                    promotions = _a.sent();
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    return [4, dispatch({
                            type: (0, action_type_util_1.SUCCESS)(types_1.LOAD_MORE),
                            payload: promotions
                        })];
                case 3:
                    _a.sent();
                    return [3, 5];
                case 4:
                    error_3 = _a.sent();
                    return [3, 5];
                case 5: return [2];
            }
        });
    }); };
};
exports.loadMore = loadMore;
var fetchPromotionDetails = function (id) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var promotion, draw, _a, error_4;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 6, , 7]);
                return [4, dispatch({
                        type: (0, action_type_util_1.REQUEST)(types_1.FETCH_PROMOTION_DETAILS)
                    })];
            case 1:
                _b.sent();
                return [4, services_1.PromotionsService.fetchPromotionDetails(id)];
            case 2:
                promotion = _b.sent();
                if (!(promotion && promotion.promotionType === types_1.PromotionType.PROGRESSIVE)) return [3, 5];
                return [4, fetchActiveDraw(promotion.id, true)];
            case 3:
                draw = _b.sent();
                if (draw) {
                    promotion.progressiveDrawDate = draw.draw;
                    promotion.progressiveEntryEndDate = draw.end;
                    promotion.progressiveDrawNumber = draw.drawNumber;
                }
                _a = promotion;
                return [4, fetchProgressivePrize(promotion.id, draw, true)];
            case 4:
                _a.progressivePrize = _b.sent();
                return [2, dispatch({
                        type: (0, action_type_util_1.SUCCESS)(types_1.FETCH_PROMOTION_DETAILS),
                        payload: promotion
                    })];
            case 5:
                dispatch({
                    type: (0, action_type_util_1.SUCCESS)(types_1.FETCH_PROMOTION_DETAILS),
                    payload: promotion
                });
                return [3, 7];
            case 6:
                error_4 = _b.sent();
                dispatch({
                    type: (0, action_type_util_1.FAILURE)(types_1.FETCH_PROMOTION_DETAILS),
                    payload: {
                        error: error_4
                    }
                });
                return [3, 7];
            case 7: return [2];
        }
    });
}); }; };
exports.fetchPromotionDetails = fetchPromotionDetails;
var fetchDrawsByPromotion = function (id) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var draws, error_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4, services_1.PromotionsService.fetchPublishedDrawsByPromotion(id)];
            case 1:
                draws = _a.sent();
                dispatch({
                    type: (0, action_type_util_1.SUCCESS)(types_1.FETCH_DRAWS_BY_PROMOTION),
                    payload: draws
                });
                return [3, 3];
            case 2:
                error_5 = _a.sent();
                return [3, 3];
            case 3: return [2];
        }
    });
}); }; };
exports.fetchDrawsByPromotion = fetchDrawsByPromotion;
var resetByPromotion = function () { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        dispatch({ type: types_1.RESET_PROMOTION });
        return [2];
    });
}); }; };
exports.resetByPromotion = resetByPromotion;
var fetchDrawEntries = function (drawId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_6;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({
                    type: (0, action_type_util_1.REQUEST)(types_1.FETCH_DRAW_ENTRY_DETAILS),
                    payload: drawId
                });
                return [4, services_1.DrawsService.fetchDrawEntryDetails(drawId)];
            case 1:
                response = _a.sent();
                dispatch({
                    type: (0, action_type_util_1.SUCCESS)(types_1.FETCH_DRAW_ENTRY_DETAILS),
                    payload: response
                });
                return [3, 3];
            case 2:
                error_6 = _a.sent();
                dispatch({
                    type: (0, action_type_util_1.FAILURE)(types_1.FETCH_DRAW_ENTRY_DETAILS),
                    payload: {
                        error: error_6
                    }
                });
                return [3, 3];
            case 3: return [2];
        }
    });
}); }; };
exports.fetchDrawEntries = fetchDrawEntries;
var selectDraw = function (draw, isDrawEnded) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, dispatch({
                    type: types_1.SELECT_DRAW,
                    payload: { draw: draw, isDrawEnded: isDrawEnded }
                })];
            case 1:
                _a.sent();
                return [2];
        }
    });
}); }; };
exports.selectDraw = selectDraw;
var selectGiveawayDraw = function (draw, isDrawEnded) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, dispatch({
                    type: types_1.SELECT_GIVEAWAY_DRAW,
                    payload: { draw: draw, isDrawEnded: isDrawEnded }
                })];
            case 1:
                _a.sent();
                return [2];
        }
    });
}); }; };
exports.selectGiveawayDraw = selectGiveawayDraw;
var selectPromotion = function (promotion) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, dispatch({
                    type: types_1.SELECT_PROMOTION,
                    payload: promotion
                })];
            case 1:
                _a.sent();
                return [2];
        }
    });
}); }; };
exports.selectPromotion = selectPromotion;
var fetchDrawWithAdditionalInformation = function (drawId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_7;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({
                    type: (0, action_type_util_1.REQUEST)(types_1.FETCH_DRAW_WITH_ADDITIONAL_INFORMATION),
                    payload: null
                });
                return [4, services_1.DrawsService.fetchDrawWithAdditionalInformation(drawId)];
            case 1:
                response = _a.sent();
                dispatch({
                    type: (0, action_type_util_1.SUCCESS)(types_1.FETCH_DRAW_WITH_ADDITIONAL_INFORMATION),
                    payload: response
                });
                return [3, 3];
            case 2:
                error_7 = _a.sent();
                dispatch({
                    type: (0, action_type_util_1.FAILURE)(types_1.FETCH_DRAW_WITH_ADDITIONAL_INFORMATION),
                    payload: {
                        error: error_7
                    }
                });
                return [3, 3];
            case 3: return [2];
        }
    });
}); }; };
exports.fetchDrawWithAdditionalInformation = fetchDrawWithAdditionalInformation;
var fetchDrawPrizes = function (drawId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_8;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({
                    type: (0, action_type_util_1.REQUEST)(types_1.FETCH_DRAW_PRIZES),
                    payload: drawId
                });
                return [4, services_1.DrawsService.fetchDrawPrizes(drawId)];
            case 1:
                response = _a.sent();
                dispatch({
                    type: (0, action_type_util_1.SUCCESS)(types_1.FETCH_DRAW_PRIZES),
                    payload: response
                });
                return [3, 3];
            case 2:
                error_8 = _a.sent();
                dispatch({
                    type: (0, action_type_util_1.FAILURE)(types_1.FETCH_DRAW_PRIZES),
                    payload: {
                        error: error_8
                    }
                });
                return [3, 3];
            case 3: return [2];
        }
    });
}); }; };
exports.fetchDrawPrizes = fetchDrawPrizes;
var fetchDrawPrizesWithContent = function (drawId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var response, prizes, error_9;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                dispatch({
                    type: (0, action_type_util_1.REQUEST)(types_1.FETCH_DRAW_PRIZES_WITH_CONTENT),
                    payload: null
                });
                return [4, services_1.PromotionsService.fetchPrizesWithWinners(drawId)];
            case 1:
                response = _a.sent();
                return [4, services_1.PromotionsService.fetchPrizesByDraw(drawId)];
            case 2:
                prizes = _a.sent();
                if (Array.isArray(response) && response.length === 0) {
                    response = prizes;
                }
                dispatch({
                    type: (0, action_type_util_1.SUCCESS)(types_1.FETCH_DRAW_PRIZES_WITH_CONTENT),
                    payload: { prizesWithContent: response, prizes: prizes }
                });
                return [3, 4];
            case 3:
                error_9 = _a.sent();
                dispatch({
                    type: (0, action_type_util_1.FAILURE)(types_1.FETCH_DRAW_PRIZES_WITH_CONTENT),
                    payload: {
                        error: error_9
                    }
                });
                return [3, 4];
            case 4: return [2];
        }
    });
}); }; };
exports.fetchDrawPrizesWithContent = fetchDrawPrizesWithContent;
var fetchLatestDrawHistory = function (drawId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_10;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({
                    type: (0, action_type_util_1.REQUEST)(types_1.FETCH_LATEST_DRAW_HISTORY),
                    payload: null
                });
                return [4, services_1.DrawsService.fetchLatestDrawHistory(drawId)];
            case 1:
                response = _a.sent();
                dispatch({
                    type: (0, action_type_util_1.SUCCESS)(types_1.FETCH_LATEST_DRAW_HISTORY),
                    payload: response
                });
                return [3, 3];
            case 2:
                error_10 = _a.sent();
                dispatch({
                    type: (0, action_type_util_1.FAILURE)(types_1.FETCH_LATEST_DRAW_HISTORY),
                    payload: {
                        error: error_10
                    }
                });
                return [3, 3];
            case 3: return [2];
        }
    });
}); }; };
exports.fetchLatestDrawHistory = fetchLatestDrawHistory;
var fetchEligibleGames = function (id) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, dispatch({
                    type: types_1.FETCH_ELIGIBLE_GAMES,
                    payload: services_1.DrawsService.fetchGamesByPromotion(id)
                }).catch(function (error) {
                    console.error(error);
                })];
            case 1:
                _a.sent();
                return [2];
        }
    });
}); }; };
exports.fetchEligibleGames = fetchEligibleGames;
var fetchEligibleGamesByIds = function (ids) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_11;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({
                    type: (0, action_type_util_1.REQUEST)(types_1.FETCH_ELIGIBLE_GAMES),
                    payload: null
                });
                return [4, services_1.GamesService.getPublishedGamesByIds(ids)];
            case 1:
                response = _a.sent();
                dispatch({
                    type: (0, action_type_util_1.SUCCESS)(types_1.FETCH_ELIGIBLE_GAMES),
                    payload: response.parsedGames
                });
                return [3, 3];
            case 2:
                error_11 = _a.sent();
                dispatch({
                    type: (0, action_type_util_1.FAILURE)(types_1.FETCH_ELIGIBLE_GAMES),
                    payload: {
                        error: error_11
                    }
                });
                return [3, 3];
            case 3: return [2];
        }
    });
}); }; };
exports.fetchEligibleGamesByIds = fetchEligibleGamesByIds;
var fetchProgressivePrizes = function () { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, promotions, featuredPromotion, prize, draw, error_12;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 5, , 6]);
                _a = getState().draws, promotions = _a.promotions, featuredPromotion = _a.featuredPromotion;
                dispatch({
                    type: (0, action_type_util_1.REQUEST)(types_1.FETCH_PROGRESSIVE_PRIZES)
                });
                if (!(!!featuredPromotion && featuredPromotion.promotionType === types_1.PromotionType.PROGRESSIVE)) return [3, 4];
                return [4, fetchProgressivePrize(featuredPromotion.id, undefined, true)];
            case 1:
                prize = _b.sent();
                if (!(featuredPromotion.progressivePrize &&
                    featuredPromotion.progressivePrize.drawId !== prize.drawId)) return [3, 3];
                return [4, fetchActiveDraw(featuredPromotion.id, true)];
            case 2:
                draw = _b.sent();
                if (draw) {
                    featuredPromotion.progressiveDrawDate = draw.draw;
                    featuredPromotion.progressiveEntryEndDate = draw.end;
                    featuredPromotion.progressiveDrawNumber = draw.drawNumber;
                }
                _b.label = 3;
            case 3:
                featuredPromotion.progressivePrize = prize;
                _b.label = 4;
            case 4:
                promotions.map(function (promotion) { return __awaiter(void 0, void 0, void 0, function () {
                    var prize, draw;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!(promotion.promotionType === types_1.PromotionType.PROGRESSIVE)) return [3, 3];
                                return [4, fetchProgressivePrize(promotion.id, undefined, true)];
                            case 1:
                                prize = _a.sent();
                                return [4, fetchActiveDraw(promotion.id, true)];
                            case 2:
                                draw = _a.sent();
                                if (draw) {
                                    promotion.progressiveDrawDate = draw.draw;
                                    promotion.progressiveEntryEndDate = draw.end;
                                    promotion.progressiveDrawNumber = draw.drawNumber;
                                }
                                promotion.progressivePrize = prize;
                                _a.label = 3;
                            case 3: return [2, promotion];
                        }
                    });
                }); });
                dispatch({
                    type: (0, action_type_util_1.SUCCESS)(types_1.FETCH_PROGRESSIVE_PRIZES),
                    payload: { promotions: promotions, featuredPromotion: featuredPromotion }
                });
                return [3, 6];
            case 5:
                error_12 = _b.sent();
                dispatch({
                    type: (0, action_type_util_1.FAILURE)(types_1.FETCH_PROGRESSIVE_PRIZES),
                    payload: error_12
                });
                return [3, 6];
            case 6: return [2];
        }
    });
}); }; };
exports.fetchProgressivePrizes = fetchProgressivePrizes;
var fetchDetailsPageProgressivePrizes = function () { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var selectedPromotion, prize, draw, error_13;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 5, , 6]);
                selectedPromotion = getState().draws.selectedPromotion;
                dispatch({
                    type: (0, action_type_util_1.REQUEST)(types_1.FETCH_DETAILS_PAGE_PROGRESSIVE_PRIZES)
                });
                if (!(selectedPromotion.promotionType === types_1.PromotionType.PROGRESSIVE)) return [3, 4];
                return [4, fetchProgressivePrize(selectedPromotion.id, undefined, true)];
            case 1:
                prize = _a.sent();
                if (!(selectedPromotion.progressivePrize &&
                    selectedPromotion.progressivePrize.drawId !== prize.drawId)) return [3, 3];
                return [4, fetchActiveDraw(selectedPromotion.id, true)];
            case 2:
                draw = _a.sent();
                if (draw) {
                    selectedPromotion.progressiveDrawDate = draw.draw;
                    selectedPromotion.progressiveEntryEndDate = draw.end;
                    selectedPromotion.progressiveDrawNumber = draw.drawNumber;
                }
                _a.label = 3;
            case 3:
                selectedPromotion.progressivePrize = prize;
                _a.label = 4;
            case 4:
                dispatch({
                    type: (0, action_type_util_1.SUCCESS)(types_1.FETCH_DETAILS_PAGE_PROGRESSIVE_PRIZES),
                    payload: selectedPromotion
                });
                return [3, 6];
            case 5:
                error_13 = _a.sent();
                dispatch({
                    type: (0, action_type_util_1.FAILURE)(types_1.FETCH_DETAILS_PAGE_PROGRESSIVE_PRIZES),
                    payload: error_13
                });
                return [3, 6];
            case 6: return [2];
        }
    });
}); }; };
exports.fetchDetailsPageProgressivePrizes = fetchDetailsPageProgressivePrizes;
var fetchProgressivePrize = function (id, draw, forPromotion) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, d, _b, prizes, e_1, e_2;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 11, , 12]);
                if (!forPromotion) return [3, 4];
                return [4, services_1.PromotionsService.fetchProgressivePrize(id)];
            case 1:
                _a = (_c.sent());
                if (_a) return [3, 3];
                return [4, fetchProgressivePrize(id, draw, false)];
            case 2:
                _a = (_c.sent());
                _c.label = 3;
            case 3: return [2, (_a)];
            case 4:
                _b = draw;
                if (_b) return [3, 6];
                return [4, fetchActiveDraw(id, true)];
            case 5:
                _b = (_c.sent());
                _c.label = 6;
            case 6:
                d = _b;
                if (!d) return [3, 10];
                _c.label = 7;
            case 7:
                _c.trys.push([7, 9, , 10]);
                return [4, services_1.PromotionsService.fetchPrizesByDraw(d.id)];
            case 8:
                prizes = _c.sent();
                return [2, prizes && prizes.length > 0 ? prizes[0] : undefined];
            case 9:
                e_1 = _c.sent();
                return [3, 10];
            case 10: return [2, undefined];
            case 11:
                e_2 = _c.sent();
                return [2, forPromotion ? fetchProgressivePrize(id, draw, false) : undefined];
            case 12: return [2];
        }
    });
}); };
var fetchActiveDraw = function (promotionId, active) { return __awaiter(void 0, void 0, void 0, function () {
    var draws, e_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 5]);
                if (!active) return [3, 2];
                return [4, services_1.PromotionsService.fetchActiveDraw(promotionId)];
            case 1: return [2, _a.sent()];
            case 2: return [4, services_1.PromotionsService.fetchPublishedDrawsByPromotion(promotionId)];
            case 3:
                draws = _a.sent();
                if (draws && draws.length > 0) {
                    return [2, draws[0]];
                }
                return [2, undefined];
            case 4:
                e_3 = _a.sent();
                return [2, active ? fetchActiveDraw(promotionId, false) : undefined];
            case 5: return [2];
        }
    });
}); };
var getGiveawayEntries = function (promotionId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var giveawayEntries, error_14;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4, services_1.PromotionsService.getGiveawayCheckinEntries(promotionId)];
            case 1:
                giveawayEntries = _a.sent();
                dispatch({
                    type: (0, action_type_util_1.SUCCESS)(types_1.GET_GIVEAWAY_PROMOTION_ENTRIES),
                    payload: giveawayEntries === null || giveawayEntries === false ? false : giveawayEntries
                });
                return [3, 3];
            case 2:
                error_14 = _a.sent();
                dispatch({
                    type: (0, action_type_util_1.FAILURE)(types_1.GET_GIVEAWAY_PROMOTION_ENTRIES),
                    payload: error_14
                });
                return [3, 3];
            case 3: return [2];
        }
    });
}); }; };
exports.getGiveawayEntries = getGiveawayEntries;
var getGiveawayEntriesDetails = function (drawId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var p, error_15;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4, services_1.PromotionsService.getGiveawayCheckinEntriesDetail(drawId)];
            case 1:
                p = _a.sent();
                dispatch({
                    type: (0, action_type_util_1.SUCCESS)(types_1.GET_GIVEAWAY_PROMOTION_ENTRIES_DETAILS),
                    payload: p === null ? 0 : p
                });
                return [3, 3];
            case 2:
                error_15 = _a.sent();
                dispatch({
                    type: (0, action_type_util_1.FAILURE)(types_1.GET_GIVEAWAY_PROMOTION_ENTRIES_DETAILS),
                    payload: error_15
                });
                return [3, 3];
            case 3: return [2];
        }
    });
}); }; };
exports.getGiveawayEntriesDetails = getGiveawayEntriesDetails;
var postGiveawayEntries = function (promotionId, entryMethod, login, giveawayDraw, callbackFunc) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var p, response, error_16;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    p = {
                        promotionId: promotionId,
                        entryMethod: entryMethod,
                        login: login
                    };
                    return [4, services_1.PromotionsService.postGiveawayCheckinEntries(p)];
                case 1:
                    response = _a.sent();
                    if (callbackFunc) {
                        callbackFunc(giveawayDraw);
                    }
                    dispatch({
                        type: (0, action_type_util_1.SUCCESS)(types_1.POST_GIVEAWAY_PROMOTION_ENTRIES),
                        payload: giveawayDraw
                    });
                    return [3, 3];
                case 2:
                    error_16 = _a.sent();
                    dispatch({
                        type: (0, action_type_util_1.FAILURE)(types_1.POST_GIVEAWAY_PROMOTION_ENTRIES),
                        payload: error_16
                    });
                    return [3, 3];
                case 3: return [2];
            }
        });
    }); };
};
exports.postGiveawayEntries = postGiveawayEntries;
var fetchGiveawayPromotionDraws = function (promotionId, pageNumber, pageSize, sort) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, error_17;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    _a = dispatch;
                    _b = {
                        type: (0, action_type_util_1.SUCCESS)(types_1.FETCH_DRAWS_BY_GIVEAWAY_PROMOTION)
                    };
                    return [4, services_1.PromotionsService.getDrawsforPromotionId(promotionId, pageNumber, pageSize, sort)];
                case 1:
                    _a.apply(void 0, [(_b.payload = _c.sent(),
                            _b)]);
                    return [3, 3];
                case 2:
                    error_17 = _c.sent();
                    dispatch({
                        type: (0, action_type_util_1.FAILURE)(types_1.FETCH_DRAWS_BY_GIVEAWAY_PROMOTION),
                        payload: error_17
                    });
                    return [3, 3];
                case 3: return [2];
            }
        });
    }); };
};
exports.fetchGiveawayPromotionDraws = fetchGiveawayPromotionDraws;
var fetchDrawPrizesById = function (drawId) { return __awaiter(void 0, void 0, void 0, function () {
    var error_18;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (drawId === undefined)
                    return [2];
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4, services_1.DrawsService.fetchDrawPrizes(drawId)];
            case 2: return [2, _a.sent()];
            case 3:
                error_18 = _a.sent();
                console.error(error_18);
                return [3, 4];
            case 4: return [2];
        }
    });
}); };
exports.fetchDrawPrizesById = fetchDrawPrizesById;
var getDrawEntries = function (promotionId, drawId) { return __awaiter(void 0, void 0, void 0, function () {
    var draws;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4, services_1.PromotionsService.fetchDraws(promotionId)];
            case 1:
                draws = _b.sent();
                if (draws.content) {
                    return [2, (_a = draws.content.find(function (draw) { return draw.id === drawId; }).entries) !== null && _a !== void 0 ? _a : 0];
                }
                return [2, 0];
        }
    });
}); };
exports.getDrawEntries = getDrawEntries;
var getDrawPrizesWithContent = function (drawId) { return __awaiter(void 0, void 0, void 0, function () {
    var prizes, error_19;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4, services_1.PromotionsService.getPrizesWithContentForDraw(drawId)];
            case 1:
                prizes = _a.sent();
                return [2, prizes];
            case 2:
                error_19 = _a.sent();
                console.error(error_19);
                return [3, 3];
            case 3: return [2];
        }
    });
}); };
exports.getDrawPrizesWithContent = getDrawPrizesWithContent;
var fetchDrawPrizesWithWinners = function (drawId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var response, _a, error_20;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 5, , 6]);
                dispatch({
                    type: (0, action_type_util_1.REQUEST)(types_1.FETCH_DRAW_PRIZES_WITH_WINNERS),
                    payload: null
                });
                if (!constants_1.default.IS_FETCH_DRAW_WINNERS_USING_DRAW_SERVICE) return [3, 2];
                return [4, services_1.DrawsService.fetchDrawPrizesWithWinners(drawId)];
            case 1:
                _a = _b.sent();
                return [3, 4];
            case 2: return [4, services_1.PromotionsService.fetchPrizesWithWinners(drawId)];
            case 3:
                _a = _b.sent();
                _b.label = 4;
            case 4:
                response = _a;
                dispatch({
                    type: (0, action_type_util_1.SUCCESS)(types_1.FETCH_DRAW_PRIZES_WITH_WINNERS),
                    payload: response
                });
                return [3, 6];
            case 5:
                error_20 = _b.sent();
                dispatch({
                    type: (0, action_type_util_1.FAILURE)(types_1.FETCH_DRAW_PRIZES_WITH_WINNERS),
                    payload: {
                        error: error_20
                    }
                });
                return [3, 6];
            case 6: return [2];
        }
    });
}); }; };
exports.fetchDrawPrizesWithWinners = fetchDrawPrizesWithWinners;
var getDrawPrizesWithWinners = function (drawId) { return __awaiter(void 0, void 0, void 0, function () {
    var prizes, _a, error_21;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 5, , 6]);
                if (!constants_1.default.IS_FETCH_DRAW_WINNERS_USING_DRAW_SERVICE) return [3, 2];
                return [4, services_1.DrawsService.fetchDrawPrizesWithWinners(drawId)];
            case 1:
                _a = _b.sent();
                return [3, 4];
            case 2: return [4, services_1.PromotionsService.fetchPrizesWithWinners(drawId)];
            case 3:
                _a = _b.sent();
                _b.label = 4;
            case 4:
                prizes = _a;
                return [2, prizes];
            case 5:
                error_21 = _b.sent();
                console.error(error_21);
                return [3, 6];
            case 6: return [2];
        }
    });
}); };
exports.getDrawPrizesWithWinners = getDrawPrizesWithWinners;
var getDrawsByPromotion = function (id) { return __awaiter(void 0, void 0, void 0, function () {
    var draws;
    return __generator(this, function (_a) {
        try {
            draws = services_1.PromotionsService.fetchPublishedDrawsByPromotion(id);
            return [2, draws];
        }
        catch (error) {
            console.error(error);
        }
        return [2];
    });
}); };
exports.getDrawsByPromotion = getDrawsByPromotion;
var getDrawWithAdditionalInformation = function (drawId) { return __awaiter(void 0, void 0, void 0, function () {
    var draw, error_22;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4, services_1.PromotionsService.fetchDrawWithAdditionalInformation(drawId)];
            case 1:
                draw = _a.sent();
                return [2, draw];
            case 2:
                error_22 = _a.sent();
                console.error(error_22);
                return [3, 3];
            case 3: return [2];
        }
    });
}); };
exports.getDrawWithAdditionalInformation = getDrawWithAdditionalInformation;
var getLatestDrawHistory = function (drawId) { return __awaiter(void 0, void 0, void 0, function () {
    var history_1, error_23;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4, services_1.DrawsService.fetchLatestDrawHistory(drawId)];
            case 1:
                history_1 = _a.sent();
                return [2, history_1];
            case 2:
                error_23 = _a.sent();
                console.error(error_23);
                return [3, 3];
            case 3: return [2];
        }
    });
}); };
exports.getLatestDrawHistory = getLatestDrawHistory;
//# sourceMappingURL=actions.js.map